import React from "react";
import { Spinner } from "reactstrap";
import { useSearchParams } from "../../lib/hooks/useSearchParams";
import { useShopHandlers } from "../../lib/hooks/useShopHandlers";
import { useShopFilterData } from "../../lib/hooks/useShopFilterData";
import { useShopContext } from "../../lib/context/ShopContext/ShopContext";

import "./ShopBySubSubCategories.scss";

export const ShopBySubSubCategories = () => {
  const shopCtx = useShopContext();
  const shopHandlers = useShopHandlers();
  const searchParams = useSearchParams();
  const shopFilterData = useShopFilterData();

  const hasOnHot = !!searchParams["tenxehta"];
  const hasNewProducts = !!searchParams["tereja"];
  const hasBrand = !!searchParams["brand"];
  const brand = searchParams["brand"];

  const handleClickSubSubCategory = (selectOption: string) => {
    const pathName = selectOption
      ? `/${shopFilterData?.redirectLinkPrefix}/${shopCtx?.data?.category}/${shopCtx?.data?.subCategory}/${selectOption}`
      : `/${shopFilterData?.redirectLinkPrefix}/${shopCtx?.data?.category}/${shopCtx?.data?.subCategory}/`;
    shopFilterData?.handleCategoryChange(selectOption || "");
    shopHandlers.updatePathname(
      pathName,
      true,
      hasOnHot
        ? "tenxehta=true"
        : undefined || hasNewProducts
        ? "tereja=true"
        : undefined || hasBrand
        ? `brand=${brand}`
        : undefined
    );
  };

  if (shopFilterData?.loading) {
    return <Spinner style={{ marginLeft: 30 }} size="lg" color="#000" />;
  }

  if (shopFilterData?.selectedSubSubCategory) {
    return <div />;
  }

  return (
    <div className="ShopBySubSubCategories">
      <div className="ShopBySubSubCategories__desc">
        <p>{shopFilterData?.subSubCategoryOptions?.description}</p>
      </div>
      <div className="ShopBySubSubCategories__wrapper">
        {shopFilterData?.subSubCategoryOptions?.subSubCategoryOptions?.map(
          (item, index) => {
            return (
              <div
                key={index}
                onClick={() => handleClickSubSubCategory(item.value)}
                className="ShopBySubCategories__wrapper-item"
              >
                {item?.icon && (
                  <div className="ShopBySubCategories__wrapper-item--img">
                    <img src={item?.icon} alt="category" />
                  </div>
                )}
                <label>{item.label}</label>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
};
